export default {"src":"/_next/static/media/windsurf.df623fa5.svg","height":2531,"width":2531,"blurWidth":0,"blurHeight":0};